function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.33341 1.99998H2.34008M7.00008 1.99998H7.00675M11.6667 1.99998H11.6734M3.00008 1.99998C3.00008 2.36817 2.7016 2.66665 2.33341 2.66665C1.96522 2.66665 1.66675 2.36817 1.66675 1.99998C1.66675 1.63179 1.96522 1.33331 2.33341 1.33331C2.7016 1.33331 3.00008 1.63179 3.00008 1.99998ZM7.66675 1.99998C7.66675 2.36817 7.36827 2.66665 7.00008 2.66665C6.63189 2.66665 6.33341 2.36817 6.33341 1.99998C6.33341 1.63179 6.63189 1.33331 7.00008 1.33331C7.36827 1.33331 7.66675 1.63179 7.66675 1.99998ZM12.3334 1.99998C12.3334 2.36817 12.0349 2.66665 11.6667 2.66665C11.2986 2.66665 11.0001 2.36817 11.0001 1.99998C11.0001 1.63179 11.2986 1.33331 11.6667 1.33331C12.0349 1.33331 12.3334 1.63179 12.3334 1.99998Z",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 4,
    viewBox: "0 0 14 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.ffe6fb57.svg";
export { ForwardRef as ReactComponent };